import { NavLink, Link } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { useUser } from '@/hooks/useAuth'
import NotificationBell from '@/components/layout/NotificationBell'

const NAV_LINKS = [
  { to: '/dashboard',  label: 'Home' },
  { to: '/needs',      label: 'Needs' },
  { to: '/villagers',  label: 'Villagers' },
  { to: '/insights',   label: 'Notes' },
]

export default function TopNav() {
  const user = useUser()
  const initial = (user?.email?.[0] ?? '?').toUpperCase()

  return (
    <header
      className="sticky top-0 z-40 border-b overflow-x-hidden"
      style={{
        background: 'rgba(251,249,244,0.85)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        borderColor: 'var(--line-2)',
      }}
    >
      <div
        className="grid items-center"
        style={{
          gridTemplateColumns: 'auto 1fr auto',
          gap: 'clamp(8px, 2vw, 32px)',
          padding: 'clamp(10px, 1.5vw, 14px) clamp(12px, 3vw, 32px)',
        }}
      >
        {/* Brand mark */}
        <div className="flex items-center gap-2 sm:gap-3 flex-none">
          <img
            src="/Logo_NoText.png"
            alt="KindredCanopy mark"
            className="w-8 h-8 sm:w-10 sm:h-10 object-contain"
          />
          <div className="hidden sm:flex flex-col leading-none">
            <span
              className="font-serif font-semibold text-[22px]"
              style={{ color: 'var(--green-900)', lineHeight: 1 }}
            >
              KindredCanopy
            </span>
            <span
              className="font-sans font-medium uppercase mt-1"
              style={{
                fontSize: '10.5px',
                letterSpacing: '0.18em',
                color: 'var(--ink-3)',
              }}
            >
              Caring together
            </span>
          </div>
        </div>

        {/* Nav links */}
        <nav className="flex items-center justify-center gap-0 sm:gap-1 overflow-x-auto no-scrollbar">
          {NAV_LINKS.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                cn(
                  'font-sans font-medium rounded-full transition-colors whitespace-nowrap',
                  'px-[10px] sm:px-[14px] py-2 text-xs sm:text-sm',
                  isActive
                    ? 'bg-[--green-100] text-[--green-900] font-semibold'
                    : 'hover:bg-[--green-050]'
                )
              }
              style={({ isActive }) => ({
                color: isActive ? 'var(--green-900)' : 'var(--ink-2)',
              })}
            >
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Actions: bell + avatar */}
        <div className="flex items-center gap-1 sm:gap-2 flex-none">
          <NotificationBell />

          <Link
            to="/profile"
            className="w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center font-sans font-semibold text-sm text-white select-none transition-opacity hover:opacity-80"
            style={{ background: 'var(--gold-500)' }}
            aria-label={`Profile — signed in as ${user?.email ?? ''}`}
            title="Your profile"
          >
            {initial}
          </Link>
        </div>
      </div>
    </header>
  )
}
